<template>
  <div class="performance-detail">
    <nav-bar titleText="团队业绩明细" @goBack="goBack" :isFixed="true" rightSize="13px" ></nav-bar>
    <div class="empty"></div>
    <div class="wrapper">
      <div class="month-detail-box">
        
        <van-dropdown-menu>
          <van-dropdown-item :title="`${param.time.getFullYear()}年${param.time.getMonth()+1}月`" ref="item">
            <van-datetime-picker
              v-model="param.time"
              type="year-month"
              title="选择年月"
              @confirm="confirmDate"
            />
          </van-dropdown-item>
        </van-dropdown-menu>

        <p class="perfor-total">业绩总计：共{{ number }}笔</p>
        <p class="amount-total">金额总计：{{ format_money(total_achievement) }}元</p>
      </div>
      <div class="select-perfor-time">
        <div class="perfor">
          <span>业绩</span>
          <img src="../../../assets/debtor/999select.png" alt=""  @click="perforSelected(-1)" v-if="param.achievement == -1">
          <img src="../../../assets/debtor/orgdown.png" alt=""  @click="perforSelected(0)" v-if="param.achievement == 0">
          <img src="../../../assets/debtor/orgselect.png" alt="" @click="perforSelected(1)" v-if="param.achievement == 1">
        </div>
        <div class="time">
          <span>加入时间</span>
          <img src="../../../assets/debtor/999select.png" alt=""  @click="timeSelected(-1)" v-if="param.join_time == -1">
          <img src="../../../assets/debtor/orgdown.png" alt=""  @click="timeSelected(0)" v-if="param.join_time == 0">
          <img src="../../../assets/debtor/orgselect.png" alt="" @click="timeSelected(1)" v-if="param.join_time == 1">
        </div>
        <span class="refresh-btn" @click="refreshList">
          <img :src="reloadgrayicon" alt="">
        </span>
      </div>

      <div class="perfor-detail-search">
        <van-search
          v-model="param.condition"
          left-icon
          show-action
          placeholder="经纪人代码/会员手机号"
          @search="onSearch"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>
      <div class="perfordetail-pull">
        <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          >
          <!-- <van-cell v-for="item in performanceList" :key="item" :title="item"/>  -->
          <div class="profor-list" v-for="(item, i) in performanceList" :key="i">
            <div class="profor-item">
              <div class="left">
                <img :src="!item.member_avator ? agentimg : item.member_avator" alt="">
                <div class="item-info">
                  <p class="name">{{item.member_realname}}</p>
                  <p class="code">
                    <span>经纪人代码</span>
                    <span>{{item.agent_code}}</span>
                  </p>
                  <p class="iphone">
                    <span>会员手机号</span>
                    <span>{{item.member_mobile}}</span>
                  </p>
                  <p class="add-time">
                    <span>加入时间</span>
                    <span>{{item.join_time}}</span>
                  </p>
                </div>
              </div>
              <div class="right">¥&nbsp;{{item.achievement}}</div>
            </div>
          </div>
        </van-list>
      <!-- </van-pull-refresh> -->
      </div>
    </div>
  </div>
</template>

<script>
import navBar from "../components/navBar";
export default {
  data() {
    return {
      performanceList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 0,
      pageSize: 10,
      number: 0,
      total_achievement: 0,
      param: {
        time: new Date(),
        achievement: 0,
        join_time: -1,
        condition: '',
      },
      // 请求锁
      lock: false,
      agentimg:require('@/assets/debtor/actver.png'),
      reloadgrayicon: require('@/assets/debt/reload-gray-icon.png'),
    }
  },
  components: {
    navBar
  },
  computed: {
    
  },
  created() {

  },
  mounted() {

  },
  methods: {
     refreshList() {
        if (!this.refreshing) {
          this.refreshing = true
          this.page = 0;
          this.onLoad();
        }
      },
    onSearch() {
      this.reOnLoad()
    },
    format_money(money, n = 2){
      const arr = String(parseFloat(money).toFixed(n)).split('.')
      return parseFloat(arr[0]).toLocaleString() + '.' + arr[1]
    },
    perforSelected(n){
      this.param.join_time = -1

      if (n == -1) this.param.achievement = 0
      if (n == 0) this.param.achievement = 1
      if (n == 1) this.param.achievement = 0

      this.reOnLoad()
    },

    timeSelected(n){
      this.param.achievement = -1

      if (n == -1) this.param.join_time = 0
      if (n == 0) this.param.join_time = 1
      if (n == 1) this.param.join_time = 0

      this.reOnLoad()
    },

    confirmDate(value){
      this.$refs.item.toggle();
      
      this.reOnLoad()
    },

    onLoad() {
      this.getproforList();
    },
    onRefresh() {
      this.page = 0;
      this.onLoad();
    },
    reOnLoad() {
      this.performanceList = [];
      this.finished = false;
      // this.onLoad()
    },
    getproforList() {

      this.page ++

      let param = {
        time: `${this.param.time.getFullYear()}-${this.param.time.getMonth()+1}`,
        // join_time: this.param.join_time,
        // achievement: this.param.join_time,
        // condition: this.param.condition,
      }

      if (this.param.join_time !== -1) param.join_time = this.param.join_time
      if (this.param.achievement !== -1) param.achievement = this.param.achievement
      if (this.param.condition) param.condition = this.param.condition
      

      this.$api.post('/debt/member/agent/performance-detail', param).then(data => {
        this.total_achievement = data.total_achievement
        this.number = data.number
        let _list = data.list

        if (this.refreshing) {
          this.performanceList = [];
          this.finished = false;
        }

        this.performanceList.push(..._list)
        if (this.performanceList.length === 0) {
          this.finished = true;
          this.loading = false;
          this.refreshing = false;
          return;
        }
        this.loading = false;
        if (data.current_page === data.last_page) {
          this.finished = true;
        }
        if (this.refreshing) {
          this.$toast("刷新成功");
          this.refreshing = false;
        }
        if (!this.finished && !this.loading && this.performanceList.length <= 3) {
          this.onLoad();
        }
      })
      .catch((err) => {
        this.loading = false;
        this.finished = true;
        if(err.message) {
          this.$toast(err.message)
        }
      });
    },
    goBack() {
      this.$router.go(-1)
    },

    // formatter(type, val) {
    //   if (type === 'month') {
    //     return `${val}月`;
    //   } else if (type === 'day') {
    //     return `${val}日`;
    //   }
    //   return val;
    // },
  }

}
</script>

<style lang="less">
.performance-detail {
  padding-top: 88px;
  .empty {
    width: 100%;
    height: 12px;
    background: #F5F6F7;
  }
  .wrapper{
    padding: 0px 12px 0 ;
    .month-detail-box {
      padding: 16px 0 7px;
      .van-hairline--top-bottom {
        position: static;
      }
      .van-dropdown-menu {
        height: auto;
        .van-dropdown-menu__item {
          flex: 0 1 auto;
        }
        .van-dropdown-menu__title {
          height: 26px;
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          line-height: 26px;
          margin-right: 3px;
          padding: 0;
          padding-right: 8px;
          &::after {
            top: 42%;
            right: -5px;
            // margin-top: -5px;
            border: 4px solid;
            border-color: transparent transparent currentColor currentColor;
            // -webkit-transform: rotate(-45deg);
            // transform: rotate(-45deg);
            opacity: 0.8;
            content: '';
          }
        }
        .van-picker__cancel, .van-picker__confirm {
          color: #fc740c;
        }
        .van-picker-column__item--selected {
          color: #fc740c;
        }
      }

      p {
        height: 21px;
        font-size: 13px;
        color: #999999;
        line-height: 21px;
      }                                                                                                                                                                                                             
    }

    .select-perfor-time {
      position: relative;
      display: flex;
      align-items: center;
      .perfor, .time {
        display: flex;
        align-items: center;
        span {
          height: 23px;
          font-size: 14px;
          color: #333333;
          line-height: 23px;
          margin-right: 7px;
        }
        img {
          width: 8px;
          height: 12px;
        }
      }
      .perfor {
        margin-right: 13px;
      }
      .refresh-btn{
        position: absolute;
          right: 10px;
          bottom: -1px;
          width: 24px;
          height: 24px;

          img {
            width: 100%;
            height: 100%;
          }
      }
    }
    .perfor-detail-search {
      .van-search {
        padding-left: 0px;
      }
      .van-search__content {
        padding-left: 12px;
        height: 35px;
        background: #F8F8F8;
        border-radius: 4px;
        border: 1px solid #EEEEEE;
      }
      .van-search__action {
        padding: 0 0 0 12px;
      }
    }

    .profor-list {
      .profor-item {
        display: flex;
        justify-content: space-between;
        padding: 12px 0 12px;
        border-bottom: 1px solid #EEEEEE;
        // align-items: center;
        .left {
          display: flex;
          img {
            width: 41px;
            height: 41px;
            margin-right: 12px;
            border-radius: 50%;
          }
          .item-info {
            .name {
              height: 26px;
              font-size: 16px;
              font-weight: 600;
              color: #333333;
              line-height: 26px;
            }
            .code, .iphone, .add-time {
              height: 21px;
              font-size: 13px;
              color: #999999;
              line-height: 21px;
              :nth-of-type(1) {
                padding-right: 5px;
              }
            }
          }
         
        }
        .right {
          height: 23px;
          font-size: 14px;
          color: #F9591B;
          line-height: 23px;
        }
      }
    }
  }
}
.perfordetail-pull{
  .van-pull-refresh{
    min-height: calc(100vh - 280px );
  }
}
</style>
